import React, { Component } from 'react';
import LibraryList from '../LibraryList';
import NavigationTabs from '../nav/NavigationTabs'
import { COLORS } from '../../styles/colors';
import { INSTRUCTION_LIBRARY_MESSAGE } from '../../static-content';
/**
 * List
 */
export class List extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    dataLoaded: false,
    instructions: {},
    isLoadMore: false
  }
  componentDidMount() {
    const { user, fetchFormFilterData } = this.props;
    this.fetchInstructions({
      creatorId: this.props.user._id || localStorage.id,
      limit: 10,
      skip: 0
    });
    fetchFormFilterData();
  }

  fetchInstructions = (query) => {
    this.props.fetchList({
      creatorId: this.props.user._id || localStorage.id,
      limit: query.limit,
      skip: query.skip,
      catId: query.categoryId,
      search: query.search
    }).then((res) => {
      let isLoadMore = true;
      let instruction = res;
      if (Object.keys(res).length < 10) {
        isLoadMore = false;
      }
      this.setState({
        dataLoaded: true,
        instructions: {
          ...this.state.instructions,
          ...res
        },
        isLoadMore: isLoadMore
      })
    });
  }

  reorder = (reqOrders, items) => {
    let obj = {};
    for(let i = 0; i < items.length; i++) {
        const d = items[i];
        obj[d._id] = d;
    }
    this.setState({
      instructions: obj
    })
    this.props.updateOrder({
      orders: reqOrders
    })
  };

  render() {
    const { user, cats, deleteInstruction } = this.props;

    return (
      <div>
        <NavigationTabs
          title="Library"
          subtitle="YouTube"
          description={INSTRUCTION_LIBRARY_MESSAGE}
          set="library"
          activeRoute="/library/instructions" />
        {this.state.dataLoaded &&
          <div style={{ marginTop: 10, border: '1px solid ' + COLORS.grey }}>
            <LibraryList
              items={Object.values(this.state.instructions)}
              categories={cats}
              categoryField="catId"
              itemType="instruction"
              user={user}
              deleteInstruction={deleteInstruction}
              reorder={this.reorder}
              isLoadMoreListing={this.state.isLoadMore}
              fetchMoreListing={this.fetchInstructions}
              resetListing  = { () => {
                this.setState({
                  instructions: []
                })
              }}
            />
          </div>}
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/instructions/List.js